/*
 * Public API Surface of pin-it-core-data
 */

export * from './lib/interfaces/entity.data.service.interface';
export * from './lib/interfaces/entity.data.service.accessor.service.interface';
export * from './lib/interfaces/local.storage.provider.interface';

export * from './lib/implementations/entity.data.service';
export * from './lib/implementations/entity.data.service.accessor.service';
export * from './lib/implementations/local.storage.provider.base';
export * from './lib/implementations/local.storage.provider';

export * from './lib/pin.it.core.data.module';
